module.exports = __webpack_public_path__ + "53d00ac34cc0896bdc4807e0cf9ceee1.png";